"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PositionCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _positionModule = _interopRequireDefault(require("./position.module.scss"));
var _icon = _interopRequireDefault(require("../../icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PositionCard = exports.PositionCard = function PositionCard(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _positionModule["default"].container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "position-card",
    className: _positionModule["default"].position,
    onClick: function onClick() {
      return props.onClick(props.id);
    }
  }, props.selected && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "selected-position",
    className: _positionModule["default"].selected
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    type: "Check"
  })), props.popular && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "popular-position",
    className: _positionModule["default"].popularContainer
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _positionModule["default"].popular
  }, "Popular!")), /*#__PURE__*/_react["default"].createElement("img", {
    src: props.preview,
    alt: props.name
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _positionModule["default"].positionName
  }, props.name)));
};
PositionCard.propTypes = {
  id: _propTypes["default"].number,
  popular: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  preview: _propTypes["default"].string,
  selected: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
PositionCard.defaultProps = {
  id: 4,
  popular: false,
  preview: "",
  selected: false
};
var _default = exports["default"] = PositionCard;